
import { defineComponent, watch, PropType } from 'vue';
import { useVModel } from 'vue-composable';
import { cloneDeep } from 'lodash';
import { formDefaults } from '@/constants';
import { VolumeAndWeightUnits } from '@/enums';
import { VendorMaterialStock } from '@/types/app';
import { createEnumerableEnum } from '@/utils';
import NumberWithMetricInput from '@/components/form-controls/NumberWithMetricInput.vue';
import MaterialsSelect from '@/components/form-controls/MaterialsSelect.vue';
import MaterialIconButton from '@/components/form-controls/MaterialIconButton.vue';
import Checkbox from '@/components/form-controls/base/CheckboxInput.vue';

export default defineComponent({
  name: 'VendorMaterialsStockSelector',
  emits: ['update:modelValue', 'input'],
  components: {
    NumberWithMetricInput,
    MaterialsSelect,
    MaterialIconButton,
    Checkbox
  },
  props: {
    modelValue: {
      type: Array as PropType<VendorMaterialStock[]>,
      required: true,
      default: cloneDeep(formDefaults.vendorMaterialsStockSelector.material)
    }
  },
  setup(props, { emit }) {
    const vendorMaterials = useVModel(props, 'modelValue');

    const enumerableVolumeAndWeightUnits = createEnumerableEnum(VolumeAndWeightUnits);

    const addVendorMaterial = () =>
      vendorMaterials.value.push(cloneDeep(formDefaults.vendorMaterialsStockSelector.material));

    const removeVendorMaterial = (index: number) => {
      vendorMaterials.value.splice(index, 1);
    };

    if (vendorMaterials.value.length === 0) {
      addVendorMaterial();
    }

    watch(vendorMaterials, () => {
      emit('update:modelValue', vendorMaterials.value);
    });

    return {
      vendorMaterials,
      enumerableVolumeAndWeightUnits,
      removeVendorMaterial,
      addVendorMaterial
    };
  }
});
